import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreConfig {
  persist?: boolean = true;
}
